import { lazy } from "react";
import { paths } from "~/router/paths";
import { app } from "~/helpers/routes";

const WatermarkRemoverPage = lazy(() => import("~/pages/watermark-remover"));

export const routes: Array<any> = [
  {
    path: paths["watermark-remover"].index,
    element: app(WatermarkRemoverPage),
  },
]; 